module.exports = __webpack_public_path__ + "img/projects.c9e72a37.png";